import { render, staticRenderFns } from "./TabCarousel.vue?vue&type=template&id=84ea8274&scoped=true"
import script from "./TabCarousel.vue?vue&type=script&lang=js"
export * from "./TabCarousel.vue?vue&type=script&lang=js"
import style0 from "./TabCarousel.vue?vue&type=style&index=0&id=84ea8274&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ea8274",
  null
  
)

export default component.exports